import React, { Component } from "react";
import ContactTextInput from "./ContactTextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import Loading from "./Loading";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
export default class Contact extends Component {
	constructor(props) {
		super(props);
		this.state = {
			empty: false,
			name: "",
			email: "",
			subject: "",
			message: "",
			loading: false,
		};
	}

	formSent = async (e) => {
		const { name, email, subject, message } = this.state;

		if (name === "" || email === "" || subject === "" || message === "") {
			e.preventDefault();
			this.setState({
				empty: true,
			});
		} else {
			e.preventDefault();
			this.setState({
				loading: true,
			});
			await fetch("/.netlify/functions/send-email", {
				method: "POST",
				body: JSON.stringify({
					name,
					email,
					subject,
					message,
				}),
			}).then((res) => {
				this.setState({
					loading: false,
				});
				if (res.status === 200) {
					console.log(res);
				} else {
					console.log("Email couldn't be sent");
				}
			});
		}
	};

	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	};

	render() {
		const { empty, name, email, subject, message, loading } = this.state;
		return (
			<section className="contact" id="contact">
				<Container>
					<h1>Contact</h1>
					<p>
						I'd like to hear from you! It doesn't have to be work
						related :)
					</p>
					{loading ? <Loading /> : null}
					<Form onSubmit={this.formSent} id="contactForm">
						<Row>
							<Col md={6}>
								<ContactTextInput
									controlId="formGroupName"
									value={name}
									onChange={this.handleChange}
									labelName="Name"
									name="name"
									placeholder="Name"
									type="text"
								/>
							</Col>
							<Col md={6}>
								<ContactTextInput
									controlId="formGroupEmail"
									value={email}
									onChange={this.handleChange}
									labelName="Email address"
									name="email"
									placeholder="Enter email"
									type="email"
								/>
							</Col>
						</Row>
						<ContactTextInput
							controlId="formGroupSubject"
							value={subject}
							onChange={this.handleChange}
							labelName="Subject"
							name="subject"
							placeholder="Subject"
							type="text"
						/>
						<Form.Group
							controlId="formGroupMessage"
							className="text-left"
						>
							<Form.Label>Message</Form.Label>
							<Form.Control
								name="message"
								value={message}
								onChange={this.handleChange}
								as="textarea"
								style={{ height: "90px" }}
								placeholder="Message"
							/>
						</Form.Group>
						<Button
							variant="secondary"
							type="submit"
							style={{ fontSize: "calc(10px + 1vmin)" }}
						>
							Submit <FontAwesomeIcon icon={faPaperPlane} />
						</Button>
						{empty ? (
							<p style={{ color: "#ff3333" }}>
								Please fill the all fields.
							</p>
						) : (
							""
						)}
					</Form>
				</Container>
			</section>
		);
	}
}
